import { render } from "./AppContainer.vue?vue&type=template&id=6a288752&scoped=true"
import script from "./AppContainer.vue?vue&type=script&lang=js"
export * from "./AppContainer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6a288752"

export default script